<app-nav titulo="Home" descripcion="¡Bienvenido a Garantor!">
</app-nav>
